export enum ZidWalletVerificationStatusEnum {
  INITIATED, // Wallet verification is initiated. This indicates the OTP is sent to the wallet owner's phone
  REVIEW_PENDING, // Wallet verification request is under review. This indicates the OTP has been validated successfully
  FAILED, // Wallet verification request is failed. This indicates user exceeded wrong OTP submission limit
  EXPIRED, // Wallet verification request is expired. This indicates the user didn't validate the OTP within time limit
  APPROVED, // Wallet verification request is approved after review
  REJECTED, // Wallet verification request is rejected after review
}
